export class EnvHttpProxyAgent {}
export default { EnvHttpProxyAgent };
